import { render, staticRenderFns } from "./AppOpenAreaContainer.vue?vue&type=template&id=1cb5ff1e&scoped=true"
import script from "./AppOpenAreaContainer.vue?vue&type=script&lang=js"
export * from "./AppOpenAreaContainer.vue?vue&type=script&lang=js"
import style0 from "./AppOpenAreaContainer.vue?vue&type=style&index=0&id=1cb5ff1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb5ff1e",
  null
  
)

export default component.exports